module.exports = __webpack_public_path__ + "assets/184b8ced10895185e99a1b5171d8cdac.png";